import { AppPreloadContext } from '#app/features/app/contexts/AppPreloadContext.js';
import { useContext, useMemo } from 'react';

export const useVisitor = () => {
  const {
    advertisementCampaigns,
    featureFlags,
    impersonator,
    ipAddress,
    sessionId,
  } = useContext(AppPreloadContext);

  return useMemo(() => {
    return {
      advertisementCampaigns,
      featureFlags,
      impersonator,
      ipAddress,
      sessionId,
    };
  }, [
    advertisementCampaigns,
    featureFlags,
    impersonator,
    ipAddress,
    sessionId,
  ]);
};
